var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "브릿지"
    },
    scopedSlots: _vm._u([{
      key: "topBtn",
      fn: function () {
        return [_c('expo-program-form', {
          on: {
            "input": _vm.updateItem
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var attrs = _ref.attrs,
                on = _ref.on;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "color": "secondary"
                }
              }, 'v-btn', attrs, false), on), [_vm._v("프로그램 생성")])];
            }
          }])
        })];
      },
      proxy: true
    }, {
      key: "contents",
      fn: function () {
        return [_c('v-sheet', [_c('v-tabs', {
          staticClass: "v-tabs--underline mb-20 mb-lg-40"
        }, [_vm._l(_vm.tabs, function (_ref2) {
          var value = _ref2.value,
            text = _ref2.text;
          return [_c('v-tab', {
            key: value,
            attrs: {
              "to": `${_vm.baseUrl}/${value}`
            }
          }, [_vm._v(" " + _vm._s(text) + " ")])];
        })], 2), _c('v-tabs-items', {
          staticClass: "fill-height",
          attrs: {
            "value": _vm.tab
          }
        }, [_c('v-tab-item', {
          attrs: {
            "value": _vm.TABS.employer.value
          }
        }, [_c('expo-program-list-filter', _vm._b({
          staticClass: "mb-20 mb-lg-40"
        }, 'expo-program-list-filter', {
          loading: _vm.loading
        }, false)), _c('list-employer', _vm._g({
          ref: _vm.TABS.employer.value,
          attrs: {
            "isActive": _vm.tab == _vm.TABS.employer.value
          }
        }, {
          setLoading: _vm.setLoading
        }))], 1), _c('v-tab-item', {
          attrs: {
            "value": _vm.TABS.host.value
          }
        }, [_c('expo-program-list-filter', _vm._b({
          staticClass: "mb-20 mb-lg-40"
        }, 'expo-program-list-filter', {
          loading: _vm.loading
        }, false)), _c('list-host', _vm._g({
          ref: _vm.TABS.host.value,
          attrs: {
            "isActive": _vm.tab == _vm.TABS.host.value
          }
        }, {
          setLoading: _vm.setLoading
        }))], 1)], 1)], 1)];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }